export default "__VITE_ASSET__gMGp_0VS__"